import { useEffect, ReactNode } from 'react'
import '@/lib/i18n'

export default function ClientLayout({ children }: { children: ReactNode }) {
  useEffect(() => {
    // i18n is initialized in lib/i18n.ts
  }, [])

  return <>{children}</>
}
